import { SVGTileLayer } from "../../components/map/svg-tile-layer.js";
//export class WindFieldTileLayer extends LSVGTileLayer {
export class WindFieldTileLayer extends SVGTileLayer {
    tileHandler;
    layerHandler;
    constructor(layer, tileHandler, layerHandler) {
        //    super();//debugging disabled
        super(layer, true); //debugging enabled
        this.tileHandler = tileHandler;
        this.layerHandler = layerHandler;
    }
    onReady(zoom, resolution, tileSize) {
        this.layerHandler(zoom, resolution, tileSize, "ready");
    }
    getViewBox(coords, tileSize, bounds) {
        return {
            minX: 0,
            minY: -tileSize.y, //N.B. sign of y is reversed
            width: tileSize.x,
            height: tileSize.y,
        };
    }
    async initTileContent(tile, coords, properties) {
        //call to super shows coordinates and tile boundaries when debugging is enabled
        //return super.initTileContent(tile,coords,properties);
        return;
    }
    /**
     * Gets called when the tile has been added to the tile layer but before the call to onReady().
     * @param tile The SVGSVGElement for this tile
     * @param coords the tile coordinates
     * @param properties the tile properties
     */
    onAddTile(tile, coords, resolution, properties) {
        this.tileHandler(properties, "add");
    }
    /**
     * Gets called when the tile has been removed from the tile layer. These call is made
     * after the onReady() call.
     * @param tile The SVGSVGElement for this tile
     * @param coords the tile coordinates
     * @param properties the tile properties
     */
    onRemoveTile(tile, coords, properties) {
        this.tileHandler(properties, "remove");
    }
}
